import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, Input, Output, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { OrderFutureDate } from '../../interfaces/order-future.interface';
import { MatBadgeModule } from '@angular/material/badge';
import multiMonthPlugin from '@fullcalendar/multimonth'
import interactionPlugin from '@fullcalendar/interaction';
import { CalendarModule, DateAdapter, CalendarView, CalendarDateFormatter } from 'angular-calendar';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-order-datepicker',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatNativeDateModule,
    OverlayModule,
    MatBadgeModule,
    FullCalendarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './order-datepicker.component.html',
  styleUrl: './order-datepicker.component.scss'
})
export class OrderDatepickerComponent {
  @Input() set initialDate(value: OrderFutureDate) {
    this.updateDate(value);
  }
  @Input() showFuture: boolean = true; // Nuevo Input Para Manejar Fechas Pasadas
  @Input() isLoading: boolean = false;
  @Output() dateChange = new EventEmitter<Date>();
  @Output() menuOpen = new EventEmitter<void>();

  total = signal(0);
  isViewMenuOpen = signal(false);

  view: CalendarView = CalendarView.Month;
  calendarOptions: any = {
    plugins: [multiMonthPlugin, interactionPlugin],
    initialView: 'multiMonthFourMonth',
    views: {
      multiMonthFourMonth: {
        type: 'multiMonth',
        duration: { months: 3 },
        buttonText: 'Year',
      },
    },
    events: [],
    headerToolbar: false,
    locale: 'es'
  };

  @ViewChild('popoverTrigger') popoverTrigger: any;
  currentEventData: any = {};

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  calendarVisibility(isVisible: boolean): void {
    this.isViewMenuOpen.set(isVisible);
    if (isVisible) {
      this.menuOpen.emit();
    }
  }

  private updateDate(value): void {
    this.total.set(value.total ?? 0);

    const events = value.days.map(dayInfo => ({
      title: `Total: ${dayInfo.total}`,
      start: dayInfo.day,
      allDay: true,
      backgroundColor: dayInfo.withTrip > 0 ? '#4caf50' : '#f44336', // Verde si tiene trip, rojo si no
      borderColor: '#fff',
      textColor: '#fff',
      extendedProps: {  // Aquí guardas info extra
        withTrip: dayInfo.withTrip,
        withoutTrip: dayInfo.withoutTrip,
        total: dayInfo.total
      }
    }));
  
    // let minDate: Date | undefined = undefined;
    // if (value.days.length > 0) {
    //   minDate = new Date(
    //     Math.min(
    //       ...value.days.map((item) => new Date(item.day).getTime())
    //     )
    //   );
    //   minDate.setDate(1);
    // } else {
    //   minDate = new Date();
    //   if (!this.showFuture) {
    //     minDate.setMonth(minDate.getMonth() - 2);
    //   }
    //   minDate.setDate(1);
    // }
    // const initialDate = new Date();
    // if (!this.showFuture) {
    //   initialDate.setMonth(initialDate.getMonth() - 2); 
    // }

      let initialDate: Date;

  if (this.showFuture) {
    // Futuro: Última fecha + 1 día (o hoy si no hay datos)
    if (value.days.length > 0) {
      const lastDate = new Date(value.days[0].day);
      lastDate.setDate(lastDate.getDate() + 1); // Día siguiente
      initialDate = lastDate;
    } else {
      initialDate = new Date(); // Hoy por defecto
    }
  } else {
    // Pasado: Primera fecha - 1 día (o 2 meses atrás si no hay datos)
    if (value.days.length > 0) {
      const firstDate = new Date(value.days[0].day);
      firstDate.setDate(firstDate.getDate() - 1); // Día anterior
      initialDate = firstDate;
    } else {
      initialDate = new Date();
      initialDate.setMonth(initialDate.getMonth() - 2); // 2 meses atrás
    }
  }

    this.calendarOptions = {
      ...this.calendarOptions,
      events,
      initialDate: initialDate,
      eventClick: (info: any) => {
        this.openPopover(info)
      },
      eventDidMount: (info: any) => {
        info.el.style.cursor = 'pointer';
      }
    };
  }

  openPopover(info: any) {
    const event = info.event;
    const date = event.startStr;
    const { withTrip, withoutTrip, total } = event.extendedProps;
    this.currentEventData = { date, withTrip, withoutTrip, total };

    // Obtener la posición del elemento clicado en el calendario
    const targetElement = info.el.getBoundingClientRect();

    const buttonElement = this.popoverTrigger._element.nativeElement;
    buttonElement.style.top = `${targetElement.top + window.scrollY}px`;
    buttonElement.style.left = `${targetElement.left + window.scrollX}px`;
    buttonElement.style.width = `${targetElement.width}px`;
    buttonElement.style.height = `${targetElement.height}px`;

    setTimeout(() => this.popoverTrigger.openMenu(), 0);
  }

  search(currentEventData: any) {
    if(!currentEventData) return;

    this.popoverTrigger.closeMenu();
    if (this.isViewMenuOpen()) {
      this.calendarVisibility(false);
    }

    const date = new Date(currentEventData);
    const fixedDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    
    this.dateChange.emit(fixedDate);
  }
}
